import type { IResponse } from '../interface';
import { fetch } from '../request';

/**
 * @description 脚本生成文件导入
 */
export const parseFile = (
  data: FormData,
): Promise<IResponse<{ status: number; text: string; task_id: string }>> => {
  return fetch('/media/aippt/script_by_file/', {
    method: 'POST',
    body: data,
    timeout: 60 * 1000,
  });
};

/**
 * @description 脚本生成文件导入异步获取结果
 */
export const fetchParseFileResult = (params: {
  task_id: string;
}): Promise<IResponse<{ status: number; text: string; task_id: string }>> => {
  return fetch('/media/aippt/task_status/', {
    method: 'GET',
    params,
  });
};
